import { render, staticRenderFns } from "./DistributionOfPayrollExpensesChart.vue?vue&type=template&id=6cdcbf41"
import script from "./DistributionOfPayrollExpensesChart.vue?vue&type=script&lang=js"
export * from "./DistributionOfPayrollExpensesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports